export default "/images/user-photo.jpg?3494828cb6de91c795a95da75b2d5b00";